import { render } from "./GifControlEditor.vue?vue&type=template&id=58499476&scoped=true"
import script from "./GifControlEditor.vue?vue&type=script&lang=ts"
export * from "./GifControlEditor.vue?vue&type=script&lang=ts"

import "./GifControlEditor.vue?vue&type=style&index=0&id=58499476&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58499476"

export default script